/** basic.roleManage */
export default {
    role_name: "Название роли",
    role_namePla: "Введите название роли",
    role_deleteTips: "Удалить эту роль?",
    role_addRole: "Добавить роль",
    role_editRole: "Изменить права роли",
    role_message: "Права не изменены",
    role_roelMenu: "Права меню",
    role_ruleName: "Введите название роли",
    role_messgeEditSucc: "Изменено!",
    role_messgeEditLose: "Не удалось изменить!",
    role_messageAddSucc: "Добавлено!",
    role_messageAddLose: "Не удалось добавить!",
}

